import React, {useState} from "react";
import Icon, {EyeInvisibleOutlined, EyeOutlined} from "@ant-design/icons";

export const EyeText = ({text}) => {
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(prev => !prev);
    };

    return (
        <div style={{display: "flex"}}>
            <p>
                {open ? text : "•".repeat(20)}
                <div
                    style={{
                        border: "1px solid #d9d9d9",
                        width: 20,
                        marginLeft: "5px",
                        height: 20,
                        display: "inline-block"
                    }}
                >
                    {open ? (
                        <EyeInvisibleOutlined
                            style={{
                                fontSize: 18,
                                top: "-1px",
                                position: "relative"
                            }}
                            onClick={handleClick}
                        />
                    ) : (
                        <EyeOutlined
                            style={{
                                fontSize: 18,
                                top: "-1px",
                                position: "relative"
                            }}
                            onClick={handleClick}
                        />
                    )}
                </div>
            </p>
        </div>
    );
};
